import { Amplify, Auth } from "aws-amplify";

const isLocalhost = window.location.hostname === "localhost";
const redirectSignInOut = isLocalhost ? "http://localhost:3000" : window.location.origin;

// Reuses the org's existing eagle-pool Cognito User Pool + "Agent" SAML SSO
// provider (Google Workspace SSO) - same setup eagleone-locator already uses,
// via a new app client registered for this app. Only gates the Agent
// dashboard route (see AuthGate.jsx) - /driver/:code stays public, it's the
// link texted to drivers who have no Eagle account.
Amplify.configure({
  Auth: {
    region: "us-east-1",
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "us-east-1_FP8QhjwAE",
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "5i7die5uu9u8a1bvirqhlmvaar",
    oauth: {
      domain: "eagleteleservices.auth.us-east-1.amazoncognito.com",
      scope: ["email", "openid"],
      redirectSignIn: redirectSignInOut,
      redirectSignOut: redirectSignInOut,
      // Authorization Code + PKCE, not implicit - avoids putting tokens in the
      // URL (browser history/referrer/log exposure). The app client already
      // allows both flows so no Cognito-side change was needed.
      responseType: "code",
    },
  },
});

export default Auth;
